import ClockOutlined from './src/clock-outlined';
export default ClockOutlined;